<main class="main">
  <div class="content">
    <div class="left-side" *ngIf="!isPreview">
      <div class="d-flex justify-content-between align-items-center mb-3">
        <div>2x Property Recommendation Old/New Price</div>
        <div class="remove-block-button">
          <a class="btn btn-sm" (click)="removeBlock()"
            ><i class="bi bi-trash-fill remove-block-icon"></i
          ></a>
        </div>
      </div>
      <div class="row">
        <div class="col-6">
          <app-block-text
            [maxLength]="500"
            [type]="'link'"
            (handleOnChange)="onChange($event, 'X2Onp1Image')"
            [blockData]="block.variables?.X2Onp1Image ?? ''"
            [placeholder]="image1Placeholder"
            variable="X2Onp1Image"
            [isImage]="true"
            [blockId]="block.blockId"
          ></app-block-text>
        </div>
        <div class="col-6">
          <app-block-text
            [type]="'link'"
            [maxLength]="500"
            (handleOnChange)="onChange($event, 'X2Onp2Image')"
            [blockData]="block.variables?.X2Onp2Image ?? ''"
            [placeholder]="image2Placeholder"
            variable="X2Onp2Image"
            [isImage]="true"
            [blockId]="block.blockId"
          ></app-block-text>
        </div>
        <div class="col-3">
          <app-block-text
            [type]="'action-link'"
            [maxLength]="500"
            (handleOnChange)="onChange($event, 'X2Onp1ImageHref')"
            [blockData]="block.variables?.X2Onp1ImageHref ?? ''"
            [placeholder]="image1HrefPlaceholder"
            variable="X2Onp1ImageHref"
            (handleOnSegmentChange)="
              handleOnSegmentChange($event, 'X2Onp1ImageHrefSegmentRegex')
            "
            [selectedSegment]="
              block.variables?.X2Onp1ImageHrefSegmentRegex ?? ''
            "
          ></app-block-text>
        </div>
        <div class="col-3">
          <app-block-text
            [type]="'action-link'"
            [maxLength]="500"
            (handleOnChange)="onChange($event, 'X2Onp2ImageHref')"
            [blockData]="block.variables?.X2Onp2ImageHref ?? ''"
            [placeholder]="image2HrefPlaceholder"
            variable="X2Onp2ImageHref"
            (handleOnSegmentChange)="
              handleOnSegmentChange($event, 'X2Onp2ImageHrefSegmentRegex')
            "
            [selectedSegment]="
              block.variables?.X2Onp2ImageHrefSegmentRegex ?? ''
            "
          ></app-block-text>
        </div>

        <div class="col-3">
          <app-block-text
            [type]="'alt'"
            [maxLength]="500"
            (handleOnChange)="onChange($event, 'X2Onp1ImageAlt')"
            [blockData]="block.variables?.X2Onp1ImageAlt ?? ''"
            [placeholder]="image1AltPlaceholder"
            variable="X2Onp1ImageAlt"
          ></app-block-text>
        </div>
        <div class="col-3">
          <app-block-text
            [type]="'alt'"
            [maxLength]="500"
            (handleOnChange)="onChange($event, 'X2Onp2ImageAlt')"
            [blockData]="block.variables?.X2Onp2ImageAlt ?? ''"
            [placeholder]="image2AltPlaceholder"
            variable="X2Onp2ImageAlt"
          ></app-block-text>
        </div>

        <div class="col-3">
          <app-block-text
            [type]="'content'"
            [maxLength]="500"
            (handleOnChange)="onChange($event, 'X2Onp2Name')"
            [blockData]="block.variables?.X2Onp2Name ?? ''"
            [placeholder]="name2Placeholder"
            variable="X2Onp2Name"
          ></app-block-text>
        </div>
        <div class="col-3">
          <app-block-text
            [type]="'content'"
            [maxLength]="500"
            (handleOnChange)="onChange($event, 'X2Onp1Name')"
            [blockData]="block.variables?.X2Onp1Name ?? ''"
            [placeholder]="name1Placeholder"
            variable="X2Onp1Name"
          ></app-block-text>
        </div>

        <div class="col-3">
          <app-block-text
            [maxLength]="500"
            [type]="'action-link'"
            (handleOnChange)="onChange($event, 'X2Onp1CtaLink')"
            [blockData]="block.variables?.X2Onp1CtaLink ?? ''"
            [placeholder]="ctaLink1Placeholder"
            variable="X2Onp1CtaLink"
            (handleOnSegmentChange)="
              handleOnSegmentChange($event, 'X2Onp1CtaLinkSegmentRegex')
            "
            [selectedSegment]="block.variables?.X2Onp1CtaLinkSegmentRegex ?? ''"
          ></app-block-text>
        </div>
        <div class="col-3">
          <app-block-text
            [maxLength]="500"
            [type]="'action-link'"
            (handleOnChange)="onChange($event, 'X2Onp2CtaLink')"
            [blockData]="block.variables?.X2Onp2CtaLink ?? ''"
            [placeholder]="ctaLink2Placeholder"
            variable="X2Onp2CtaLink"
            (handleOnSegmentChange)="
              handleOnSegmentChange($event, 'X2Onp2CtaLinkSegmentRegex')
            "
            [selectedSegment]="block.variables?.X2Onp2CtaLinkSegmentRegex ?? ''"
          ></app-block-text>
        </div>

        <div class="col-4">
          <app-block-text
            [type]="'content'"
            (handleOnChange)="onChange($event, 'X2Onp1CtaText')"
            [blockData]="block.variables?.X2Onp1CtaText ?? ''"
            [placeholder]="ctaText1Placeholder"
            variable="X2Onp1CtaText"
            [maxLength]="30"
          ></app-block-text>
        </div>
        <div class="col-4">
          <app-block-text
            [type]="'content'"
            (handleOnChange)="onChange($event, 'X2Onp2CtaText')"
            [blockData]="block.variables?.X2Onp2CtaText ?? ''"
            [placeholder]="ctaText2Placeholder"
            variable="X2Onp2CtaText"
            [maxLength]="30"
          ></app-block-text>
        </div>

        <div class="col-4">
          <app-block-text
            [type]="'content'"
            [maxLength]="25"
            (handleOnChange)="onChange($event, 'X2Onp1OldPrice')"
            [blockData]="block.variables?.X2Onp1OldPrice ?? ''"
            [placeholder]="oldPrice1Placeholder"
            variable="X2Onp1OldPrice"
          ></app-block-text>
        </div>
        <div class="col-4">
          <app-block-text
            [maxLength]="25"
            [type]="'content'"
            (handleOnChange)="onChange($event, 'X2Onp1NewPrice')"
            [blockData]="block.variables?.X2Onp1NewPrice ?? ''"
            [placeholder]="newPrice1Placeholder"
            variable="X2Onp1NewPrice"
          ></app-block-text>
        </div>

        <div class="col-4">
          <app-block-text
            [maxLength]="25"
            [type]="'content'"
            (handleOnChange)="onChange($event, 'X2Onp2OldPrice')"
            [blockData]="block.variables?.X2Onp2OldPrice ?? ''"
            [placeholder]="oldPrice2Placeholder"
            variable="X2Onp2OldPrice"
          ></app-block-text>
        </div>
        <div class="col-4">
          <app-block-text
            [maxLength]="25"
            [type]="'content'"
            (handleOnChange)="onChange($event, 'X2Onp2NewPrice')"
            [blockData]="block.variables?.X2Onp2NewPrice ?? ''"
            [placeholder]="newPrice2Placeholder"
            variable="X2Onp2NewPrice"
          ></app-block-text>
        </div>
      </div>
    </div>
    <div
      class="right-side-container"
      [id]="block.blockId"
      (click)="onContainerClick($event)"
    >
      <app-pin [block]="block"></app-pin>
      <div class="right-side">
        <div class="row text-center">
          <div class="col-6" *ngIf="block.variables?.X2Onp1Image">
            <a
              target="_blank"
              [href]="helper.getFullUrl($safeNavigationMigration(block.variables?.X2Onp1ImageHref))"
              ><img
                [src]="$safeNavigationMigration(block.variables?.X2Onp1Image)"
                class="img-fluid"
                [alt]="$safeNavigationMigration(block.variables?.X2Onp1ImageAlt)"
            /></a>
          </div>
          <div class="col-6" *ngIf="block.variables?.X2Onp2Image">
            <a
              target="_blank"
              [href]="helper.getFullUrl($safeNavigationMigration(block.variables?.X2Onp2ImageHref))"
              ><img
                [src]="$safeNavigationMigration(block.variables?.X2Onp2Image)"
                class="img-fluid"
                [alt]="$safeNavigationMigration(block.variables?.X2Onp2ImageAlt)"
            /></a>
          </div>
        </div>
        <div class="row text-left mt-2">
          <div class="col-6">
            <p [innerHTML]="$safeNavigationMigration(block.variables?.X2Onp1Name)"></p>
          </div>
          <div class="col-6">
            <p [innerHTML]="$safeNavigationMigration(block.variables?.X2Onp2Name)"></p>
          </div>
        </div>
        <div class="row text-left mt-2">
          <div class="col-6 d-flex">
            <div class="col-6">
              <p>Per day/<br />starting from</p>
            </div>
            <div class="col-3">
              <p
                style="text-decoration: line-through"
                [innerHTML]="$safeNavigationMigration(block.variables?.X2Onp1OldPrice)"
              ></p>
            </div>
            <div class="col-3">
              <p [innerHTML]="$safeNavigationMigration(block.variables?.X2Onp1NewPrice)"></p>
            </div>
          </div>
          <div class="col-6 d-flex">
            <div class="col-6">
              <p>Per day/<br />starting from</p>
            </div>
            <div class="col-3">
              <p
                style="text-decoration: line-through"
                [innerHTML]="$safeNavigationMigration(block.variables?.X2Onp2OldPrice)"
              ></p>
            </div>
            <div class="col-3">
              <p [innerHTML]="$safeNavigationMigration(block.variables?.X2Onp2NewPrice)"></p>
            </div>
          </div>
        </div>
        <div class="row text-left mt-2">
          <div class="col-6">
            <a
              class="btn btn-primary"
              [href]="helper.getFullUrl($safeNavigationMigration(block.variables?.X2Onp1CtaLink))"
              target="_blank"
              *ngIf="block.variables?.X2Onp1CtaLink"
              [innerHTML]="$safeNavigationMigration(block.variables?.X2Onp1CtaText)"
            ></a>
          </div>
          <div class="col-6">
            <a
              class="btn btn-primary"
              [href]="helper.getFullUrl($safeNavigationMigration(block.variables?.X2Onp2CtaLink))"
              target="_blank"
              *ngIf="block.variables?.X2Onp2CtaLink"
              [innerHTML]="$safeNavigationMigration(block.variables?.X2Onp2CtaText)"
            ></a>
          </div>
        </div>
      </div>
    </div>
    <div class="comments-side" *ngIf="!isPreview">
      <app-notification
        [notifications]="block.notifications"
        [blockId]="block.blockId"
      ></app-notification>
    </div>
  </div>
</main>
